import { type FormEvent, useState } from 'react';

export function AcademyOnboarding({ onCreate, onRedeem, onSignOut, logo }: {
  onCreate: (name: string) => Promise<void>;
  onRedeem: (code: string) => Promise<void>;
  onSignOut: () => void;
  logo: React.ReactNode;
}) {
  const [academyName, setAcademyName] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run(action: () => Promise<void>) {
    setBusy(true);
    setError(null);
    try { await action(); } catch (exception) { setError(readableError(exception)); } finally { setBusy(false); }
  }

  function create(event: FormEvent) {
    event.preventDefault();
    void run(() => onCreate(academyName));
  }

  function redeem(event: FormEvent) {
    event.preventDefault();
    void run(() => onRedeem(inviteCode));
  }

  return <main className="auth-shell"><div className="auth-card onboarding-card">{logo}
    <p className="eyebrow">One last step</p><h1>Connect your academy.</h1>
    <p>Create a new academy as its owner, or join an existing academy with a coach invitation.</p>
    <form className="auth-form" onSubmit={create}><label>Academy name<input required minLength={2} maxLength={120} value={academyName} onChange={(event) => setAcademyName(event.target.value)} placeholder="Harbour Jiu-Jitsu Academy" /></label><button className="button primary wide" disabled={busy}>Create academy</button></form>
    <div className="or"><span>or</span></div>
    <form className="auth-form" onSubmit={redeem}><label>Coach invitation code<input required minLength={8} autoCapitalize="characters" value={inviteCode} onChange={(event) => setInviteCode(event.target.value.toUpperCase())} placeholder="Enter code" /></label><button className="button ghost wide" disabled={busy}>Join coaching team</button></form>
    {error && <p className="form-message" role="alert">{error}</p>}
    <button className="text-link auth-switch" onClick={onSignOut}>Sign out</button>
  </div></main>;
}

function readableError(error: unknown): string {
  if (typeof error === 'object' && error && 'message' in error) return String(error.message);
  return 'That did not work. Please try again.';
}
